export const Mission = () => {
	const title1 = "What have you been reading?";
	const body1 =
		"The library team would love to know what you have been reading. Whether it is to learn a new skill or grow within one, we will be able to provide the top content for you!";
	const title2 = "Our collection is always changing!";
	const body2 =
		"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque ultricies tortor vel purus imperdiet dapibus. Etiam neque libero, ornare ut urna non, ornare feugiat ipsum. Maecenas sit amet lectus sed felis gravida luctus. Quisque finibus convallis ipsum ac rutrum. ";

	return (
		<div>
			<div className="d-none d-lg-block">
				<div className="row g-0 mt-5">
					<div className="col-sm-6 col-md-6">
						<div className="col-image-left"></div>
					</div>
					<div className="col-4 col-md-4 container d-flex justify-content-center align-items-center">
						<div className="ml-2">
							<h1 className="comic-font">{title1}</h1>
							<p className="lead">{body1}</p>
							<a
								className="btn main-color btn-lg text-white"
								href="#"
							>
								Sign up
							</a>
						</div>
					</div>
				</div>
				<div className="row g-0">
					<div
						className="col-4 col-md-4 container d-flex 
                        justify-content-center align-items-center"
					>
						<div className="ml-2">
							<h1 className="comic-font">{title2}</h1>
							<p className="lead">{body2}</p>
						</div>
					</div>
					<div className="col-sm-6 col-md-6">
						<div className="col-image-right"></div>
					</div>
				</div>
			</div>

			{/* Mobile Heros */}
			<div className="d-lg-none">
				<div className="container">
					<div className="m-2">
						<div className="col-image-left"></div>
						<div className="mt-2">
							<h1 className="comic-font">{title1}</h1>
							<p className="lead">{body1}</p>
							<a
								className="btn main-color btn-lg text-white"
								href="#"
							>
								Sign up
							</a>
						</div>
					</div>
					<div className="m-2">
						<div className="col-image-right"></div>
						<div className="mt-2">
							<h1 className="comic-font">{title2}</h1>
							<p className="lead">{body2}</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
